<template>
    <div class="seller-o2o-index">
        <div class="common-header-wrap">
            <mt-header title="店铺设置" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
      <div class="user-avatar iconfont icon-xiangji" ref="upload_btn" @change="uploadAvatar($event,'store_avatar')">
        <img v-if="store_avatar_url" :src="store_avatar_url">
        <input type="hidden" v-model="store_avatar">
        <input type="file" accept="image/*">
      </div>
	  <div class="main-content">
		  <div @click="showBanner=true"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">店铺横幅</span><div slot="right">{{store_banner_url?'已上传':'未上传'}}</div></flex-line></div>
		  <flex-line class="field-line" :show-border="true"><span class="field-name">主营商品</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_mainbusiness" /></div></flex-line>
		  <flex-line class="field-line" :show-border="true"><span class="field-name">QQ</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_qq" /></div></flex-line>
		  <flex-line class="field-line" :show-border="true"><span class="field-name">阿里旺旺</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_ww" /></div></flex-line>
		  <flex-line class="field-line" :show-border="true"><span class="field-name">关键</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_keywords" /></div></flex-line>
		  <flex-line class="field-line" :show-border="true"><span class="field-name">店铺</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_description" /></div></flex-line>
		  <flex-line class="field-line" :show-border="true"><span class="field-name">店铺电话</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_phone" /></div></flex-line>
		  <div class="pt-10 pb-10"><div class="common-btn ds-button-large" v-on:click="submit">保存</div></div>
	  </div>
        <mt-popup v-model="showBanner" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="店铺横幅" class="common-header">
                    <mt-button slot="left" icon="back" @click="showBanner=false"></mt-button>
                    <mt-button slot="right">
                    <div @change="uploadAvatar($event,'store_banner')">
                    上传
                    <input type="hidden" v-model="store_banner">
                    <input type="file" accept="image/*" style="position:absolute;left:0;right:0;top:0;bottom:0;opacity:0">
                    </div>
                    </mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
            <img :src="store_banner_url" width="100%">
            </div>
        </mt-popup>
        <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="裁剪图片" class="common-header">
                    <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
					<div class="common-btn btn" slot="right" @click="useCrop">使用</div>
                </mt-header>
            </div>
            <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
        </mt-popup>
    </div>
</template>

<script>
    import { VueCropper } from 'vue-cropper'
import { uploadStoreImage,getStoreInfo, editStoreInfo } from '../../../api/sellerSetting'
    import { Toast, Indicator } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
  name: 'SellerSettingInfo',
  data () {
    return {
        cropType: '',
        cropperOption: {
            img: '',
            canMove: false,
            autoCrop: true,
            autoCropWidth: 100,
            autoCropHeight: 100,
            maxImgSize: 500,
            outputType: 'png'
        },
        showCrop: false,
    showBanner:false,
    store_avatar:'',
    store_avatar_url:'',
    store_banner:'',
    store_banner_url:'',
      settings: {}
    }
  },
  created: function () {
    getStoreInfo().then(res => {
      this.settings = res.result.store_info
      this.store_avatar=this.settings.store_avatar
      this.store_avatar_url=this.settings.store_avatar_url
      this.store_banner=this.settings.store_banner
      this.store_banner_url=this.settings.store_banner_url
    }).catch(function (error) {
      Toast(error.message)
    })
  },
    components: {
        VueCropper,
		flexLine
    },
  computed: {

  },
  methods: {
    submit () {
      editStoreInfo(this.settings.store_qq, this.settings.store_ww, this.settings.store_phone, this.settings.store_mainbusiness, this.settings.store_keywords, this.settings.store_description, this.store_avatar, this.store_banner).then(res => {
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
      uploadAvatar (event,type) {
          let that = this
          this.cropType = type
          let file = event.target.files[0]
          let reader = new FileReader()
          let rs = reader.readAsDataURL(file)
          reader.onload = (e) => {
              that.cropperOption.img = e.target.result
              let image = new Image()
              image.src = e.target.result
              image.onload = function () {
                  that.cropperOption.autoCropWidth = window.screen.width
                  that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
                  that.cropperOption.maxImgSize = window.screen.height - 40
                  that.showCrop = true
                  that.$forceUpdate()
              }
          }
      },
      useCrop () {
          let type = this.cropType
          this.$refs.cropper.getCropBlob(res => {
              let files = new window.File([res], 'temp.png', { type: res.type })
              let formdata = new FormData()

              formdata.append(type, files)
              formdata.append('id', type)
              Indicator.open()
              uploadStoreImage(formdata).then(res => {
                  if(type=='store_avatar'){
                      this.store_avatar = res.result.file_name
                      this.store_avatar_url = res.result.file_path
                  }else{
                      this.store_banner = res.result.file_name
                      this.store_banner_url = res.result.file_path
                  }
                  this.showCrop = false
                  Indicator.close()
              }).catch(function (error) {
                  Toast(error.message)
                  Indicator.close()
              })
          })
      }
  }
}
</script>
<style lang="scss" scoped>
.common-header{
	.btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
}
.main-content{background: #fff;padding:0 $pageSpace}
.user-avatar {
      position: relative;
      width: 5rem;
      height: 5rem;
      margin: 2rem auto;
      text-align: center;
      border:1px solid #e0e0e0;
      img {
        width: 100%;
        height: 100%
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0
      }
    }
    .user-avatar::before {
      position: absolute;
      font-size: 1.5rem;
      line-height: 5rem;
      left: 50%;
      margin-left: -.75rem;
      color: rgba(0, 0, 0, 0.5)
    }
</style>
